// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Lo que de verdad escribió Pau en un mensaje al agente (13-10). Código PURO (se copia a la web): lo usan el chat
// (web chat/linea-de-tiempo.ts), el resumidor de la ficha y el buscador (backend).

/**
 * Pau: «le escribo y sale "la oficina le ha dado un aviso" pero mi mensaje ya no lo veo». Durante un cierre o un
 * integrar, la oficina le pone al agente un aviso DELANTE del mensaje de Pau (repo.avisoCierre). Devuelve lo que
 * escribió Pau, sin el aviso; null si el mensaje no es de esos.
 */
export function textoDePauConAviso(texto: string): string | null {
  const m = /^⟦OFICINA — PAU TE ESCRIBE[^⟧]*⟧[\s\S]*?\n\n([\s\S]+)$/.exec(texto.trim());
  return m ? m[1]!.trim() : null;
}

/**
 * Pau: «cuando abro un agente nuevo no veo mi mensaje». Su encargo va dentro del brief (compilar-brief.ts): en
 * <mision>, o en <material> (<contenido_pegado>) si era largo. El brief cambia ‹› por <> en su texto: se deshace.
 */
export function encargoDelBrief(brief: string): string {
  const seccion = (n: string) => new RegExp(`<${n}>\\n([\\s\\S]*?)\\n</${n}>`).exec(brief)?.[1] ?? '';
  const pegado = /<contenido_pegado origen="pau">\n([\s\S]*?)\n<\/contenido_pegado>/.exec(brief)?.[1];
  const texto = pegado ?? seccion('mision');
  return texto.replace(/‹/g, '<').replace(/›/g, '>').trim();
}

/** Para buscar sin que importen mayúsculas ni tildes («Precio» encuentra «precio», «pagó» encuentra «pago»). */
export function normalizarBusqueda(texto: string): string {
  return texto.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
}

/**
 * 14-10 (Pau: «dentro de los pasos de trabajo se me esconden mensajes que yo debería leer»; medido en 3 días: unos 200
 * mensajes para él plegados, casi todos largos o la primera contestación a lo que preguntó). Un texto suelto del agente
 * con esta pinta NO es narración de pasos («ahora miro…», medido: cortos): se le enseña a Pau aunque no sea el último
 * del turno. El chat (web chat/linea-de-tiempo.ts) y el resumidor de la ficha (para darle su «en corto») usan esta regla.
 */
export const LARGO_PARA_PAU = 400;
/** La primera contestación a un mensaje de Pau (antes de ponerse a trabajar) se ve a partir de este largo; «Me pongo.» no. */
export const LARGO_RESPUESTA_DIRECTA = 120;

/** `sinPregunta`: la pregunta ya le sale aparte (en la tarjeta de la oficina), así que «¿» no basta. */
export function pareceParaPau(texto: string, o: { respuestaDirecta?: boolean; sinPregunta?: boolean } = {}): boolean {
  const t = texto.trim();
  if (t.length >= LARGO_PARA_PAU) return true;
  if (o.respuestaDirecta && t.length >= LARGO_RESPUESTA_DIRECTA) return true;
  // Una pregunta en español es para Pau (el agente no se pregunta a sí mismo con «¿»).
  return !o.sinPregunta && t.includes('¿');
}
